export default __webpack_public_path__ + "static/media/37.fb281935.png";